import React from "react";

import VideosSection from "../../components/VideoSection/VideoSection";
import { customerSupportVideos } from "../../helpers/videos";

export default function HowToCustomerSupport() {
  return <VideosSection videos={customerSupportVideos} />;
}
